// Port of api/fuel/app/classes/filter/package/games/game/package/about.php

// Cache parsed JSON columns by game_id within a single package run.
// Without this, every result row re-parses up to 5 JSON columns from
// the same game (game_players_community, game_players_best,
// game_players_recommended, game_language_votes, game_contains).
// The cache lives on `global._aboutParsed` and is cleared automatically
// when a new package run starts because each call gets a fresh `global`.
function tryParse(s) {
	if (!s) return null
	try { return JSON.parse(s) } catch (e) { return s }
}

function computeRecommended(community) {
	// Mirror PHP `Model\Game::get_players_recommended()` — recompute from
	// the community poll at query time. The stored `game_players_recommended`
	// column can hold stale entries (b+r≤n now but ≥n historically), and
	// PHP's getter ignores it entirely.
	if (!community || typeof community !== 'object') return []
	var out = []
	var keys = Object.keys(community)
	for (var i = 0; i < keys.length; i++) {
		var entry = community[keys[i]]
		if (!entry) continue
		var b = parseInt(entry.b, 10) || 0
		var r = parseInt(entry.r, 10) || 0
		var n = parseInt(entry.n, 10) || 0
		if (b + r > n) out.push(keys[i])
	}
	return out
}

function getParsed(global, game) {
	var gid = game.game_id
	var cache = global._aboutParsed
	if (!cache) cache = global._aboutParsed = {}
	var entry = cache[gid]
	if (entry) return entry
	var community = tryParse(game.game_players_community) || []
	entry = {
		community: community,
		best: tryParse(game.game_players_best) || [],
		recommended: computeRecommended(community),
		language_votes: tryParse(game.game_language_votes),
		contains: tryParse(game.game_contains) || []
	}
	cache[gid] = entry
	return entry
}

function round(value, places) {
	if (!value) return 0
	var factor = Math.pow(10, places)
	return Math.round(parseFloat(value) * factor) / factor
}

export default {
	run: function(pkg, local, global) {
		var game = local.game
		if (!game) return pkg
		var parsed = getParsed(global, game)
		var version = false
		if (local.versions && local.versions.user && global.versionsReference) {
			version = global.versionsReference[local.versions.user] || false
		}
		var ratingAvg = +game.game_rating_avg || 0
		var containsEnabled = global.settings && global.settings.session && global.settings.session.collection && global.settings.session.collection.contains
		pkg.game = {
			id: local.game_id,
			type: game.game_type || 1,
			name: local.rename || game.game_name || '',
			originalName: game.game_name || '',
			rename: local.rename || '',
			players_min: game.game_players_min || 0,
			players_max: game.game_players_max || 0,
			players_community: {
				best: parsed.best,
				recommended: parsed.recommended,
				count: game.game_players_count || 0,
				votes: parsed.community
			},
			time_min: game.game_time_min || 0,
			time_max: game.game_time_max || 0,
			rating_avg: ratingAvg ? Math.round(ratingAvg * 10) / 10 : 0,
			rating_count: game.game_rating_count || 0,
			rating_band: ratingAvg ? Math.floor(ratingAvg) : 0,
			rank: game.game_rank || 0,
			owners: game.game_own || 0,
			age_official: game.game_age_official || 0,
			age_community: game.game_age_community || 0,
			weight_avg: round(game.game_weight_avg, 2),
			weight_count: game.game_weight_count || 0,
			color: game.game_color || '72,129,187',
			published: game.game_published || 0,
			expansions: local.expansions || 0,
			language: { count: game.game_language_count || 0, rating: game.game_language_dependency || 0, votes: parsed.language_votes },
			worth: { value: game.game_worth_value || 0 },
			contains: containsEnabled ? parsed.contains : [],
			version: version ? {
				id: version.game_version_id,
				name: version.game_version_name,
				localised: version.game_version_localised,
				year: version.game_version_year,
				worth: {
					value: version.game_version_worth_value
				},
				size: {
					width: version.game_version_storage_width || 0,
					length: version.game_version_storage_length || 0,
					depth: version.game_version_storage_depth || 0,
					weight: version.game_version_storage_weight || 0
				}
			} : false
		}
		return pkg
	}
}
